/**
 * @generated SignedSource<<50a75d21ac3c3466e42f7a6d2bcd8e6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteSourceTagInput = {
  clientMutationId?: string | null;
  sourceTagId: string;
};
export type SourceTagReferenceModal_DeleteMutation$variables = {
  input: DeleteSourceTagInput;
};
export type SourceTagReferenceModal_DeleteMutationVariables = SourceTagReferenceModal_DeleteMutation$variables;
export type SourceTagReferenceModal_DeleteMutation$data = {
  readonly deleteSourceTag: {
    readonly deletedSourceTagId: string;
  } | null;
};
export type SourceTagReferenceModal_DeleteMutationResponse = SourceTagReferenceModal_DeleteMutation$data;
export type SourceTagReferenceModal_DeleteMutation = {
  variables: SourceTagReferenceModal_DeleteMutationVariables;
  response: SourceTagReferenceModal_DeleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteSourceTagPayload",
    "kind": "LinkedField",
    "name": "deleteSourceTag",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedSourceTagId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SourceTagReferenceModal_DeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SourceTagReferenceModal_DeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e093f001863d633d639396b50a926ae2",
    "id": null,
    "metadata": {},
    "name": "SourceTagReferenceModal_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation SourceTagReferenceModal_DeleteMutation(\n  $input: DeleteSourceTagInput!\n) {\n  deleteSourceTag(input: $input) {\n    deletedSourceTagId\n  }\n}\n"
  }
};
})();

(node as any).hash = "64f844b669e085293cd2e08c39a41364";

export default node;
